interface SparklineProps {
  points: ReadonlyArray<number>;
  dashed?: boolean;
}

export function Sparkline({ points, dashed = false }: SparklineProps) {
  if (points.length === 0) return null;

  const width = 100;
  const height = 30;
  const max = Math.max(...points);
  const min = Math.min(...points);
  const range = max - min || 1;
  const step = width / (points.length - 1 || 1);

  const coords = points.map((p, i) => {
    const x = i * step;
    const y = height - 2 - ((p - min) / range) * (height - 4);
    return [x, y] as const;
  });

  const line = coords.map(([x, y], i) => (i === 0 ? `M${x},${y}` : `L${x},${y}`)).join(' ');
  const area = `${line} L${width},${height} L0,${height} Z`;

  return (
    <svg
      className="h-8 w-full overflow-visible"
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="none"
      aria-hidden
    >
      {!dashed ? (
        <>
          <path d={area} fill="url(#spark-fill)" opacity={0.08} />
          <defs>
            <linearGradient id="spark-fill" x1="0" x2="0" y1="0" y2="1">
              <stop offset="0%" stopColor="currentColor" stopOpacity="1" />
              <stop offset="100%" stopColor="currentColor" stopOpacity="0" />
            </linearGradient>
          </defs>
        </>
      ) : null}
      <path
        d={line}
        fill="none"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={dashed ? 'text-ink-muted' : 'text-ink'}
        strokeDasharray={dashed ? '2 3' : undefined}
      />
    </svg>
  );
}
